import { createClient } from "@supabase/supabase-js";

const fallbackUrl = "https://zptimuzupaojeumfzkde.supabase.co";
const fallbackAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpwdGltdXp1cGFvamV1bWZ6a2RlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI0NDY1NjYsImV4cCI6MjA0ODAyMjU2Nn0.E2BuKrpNh3KWaKwc88BEGX4GG7T2SpTP3B0VSwnLcO8";

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || fallbackUrl;
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || fallbackAnonKey;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
